import React, { useId, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon } from 'lucide-react';
import { searchProducts, fromPrice } from '../../utils/products';
import { formatPrice } from '../../utils/currency';
export function SearchBox({
  onNavigate,
  autoFocus
}: {
  onNavigate?: () => void;
  autoFocus?: boolean;
}) {
  const id = useId();
  const [query, setQuery] = useState('');
  const [focused, setFocused] = useState(false);
  const navigate = useNavigate();
  const results = searchProducts(query);
  const showPanel = focused && query.trim().length > 0;
  const go = (slug: string) => {
    navigate(`/product/${slug}`);
    setQuery('');
    setFocused(false);
    onNavigate?.();
  };
  return <form role="search" className="relative w-full" onSubmit={e => {
    e.preventDefault();
    if (results[0]) go(results[0].slug);
  }} data-id="element-238" data-mp="2daksydpft2j7">
      <label htmlFor={id} className="sr-only" data-id="element-239" data-mp="11wpgxdttx9w7">Zoek producten</label>
      <SearchIcon className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-240" data-mp="11yk1gr16uzzr" />
      <input id={id} type="search" value={query} autoComplete="off" autoFocus={autoFocus} onChange={e => setQuery(e.target.value)} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} onKeyDown={e => e.key === 'Escape' && setFocused(false)} placeholder="Zoek arganolie, zwarte zeep, kessa…" className="h-11 w-full rounded-full border border-line bg-white pl-11 pr-4 text-sm text-ink placeholder:text-muted focus:border-ink focus:outline-none" data-id="element-241" data-mp="12gzfic97rsmf" />
      {showPanel && <div className="absolute inset-x-0 top-full z-50 mt-2 overflow-hidden rounded-2xl border border-line bg-white shadow-[0_16px_40px_-16px_rgba(28,23,20,0.25)]" data-id="element-242" data-mp="9sjyxlafp28z">
          {results.length === 0 ? <p className="px-4 py-5 text-sm text-muted" data-id="element-243" data-mp="rvtvg30qc88">Geen producten gevonden voor “{query}”.</p> : <ul data-id="element-244" data-mp="22hkz714usyby">
              {results.map(p => <li key={p.slug} data-id="element-245" data-mp="22j4fusuf9be9">
                  <button type="button" onMouseDown={e => e.preventDefault()} onClick={() => go(p.slug)} className="flex w-full items-center gap-3 px-3 py-2.5 text-left transition-colors duration-150 hover:bg-canvas" data-id="element-246" data-mp="1xql1vurtoe8x">
                    <img src={p.image} alt="" className="h-11 w-11 rounded-lg bg-surface object-cover" data-id="element-247" data-mp="2lg5nymj9vrmf" />
                    <span className="flex-1" data-id="element-248" data-mp="2ghvqg5a2sexn">
                      <span className="block text-sm font-medium text-ink" data-id="element-249" data-mp="2gezs4fubfo8o">{p.name}</span>
                      <span className="block text-xs text-muted" data-id="element-250" data-mp="2chbv9792ble5">{p.subtitle}</span>
                    </span>
                    <span className="text-sm font-medium text-ink" data-id="element-251" data-mp="27ih0d6xtm6do">{formatPrice(fromPrice(p))}</span>
                  </button>
                </li>)}
            </ul>}
        </div>}
    </form>;
}